export {
  type ElementOrFactory,
  type ReactToLit,
  useLitPortal,
  useLitPortalFactory,
} from './lit-portal';
export { uniReactRoot } from './uni-component';
